// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"0b61c79a","128":"49aca12f","241":"bc29fbe9","293":"26918157","297":"10f74088","335":"a0e57cf6","470":"ed386db9","476":"ba21b4fe","670":"e04d9286","758":"98f44c6e","853":"c3fd0f59","896":"7b370a0a"}[chunkId] + ".chunk.js";
};